import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useListMachineSanitary = () => {

    const [catMachinesSanitary, setcatMachinesSanitary] = useState([]);
    const [id_machine_sanitary, setid_machine_sanitary] = useState(0);
    const [dataDatacatMachinesSanitarySearch, setDatacatMachinesSanitarySearch] = useState([]);

  
    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle,setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const history = useHistory();
    const [loadingExport, setLoadingExport] = useState(false);
    const [machineSanitaryData, setMachineSanitaryData] = useState([]);
    const [searchMachineSanitary, setSearchMachineSanitary] = useState("");

    const [formValues,handleInputChange, reset, handleUpdateValues,] = useForm({
        descripcion:"",
        clave:"",
    });
    const [validaciones, setValidaciones] = useState({
        descripcion_valid:false,
    })
    const {descripcion,clave } = formValues;

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(catMachinesSanitary.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listcatMachinesSanitary = [];
        catMachinesSanitary.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listcatMachinesSanitary.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setcatMachinesSanitary(listcatMachinesSanitary);
        setMachineSanitaryData(listcatMachinesSanitary);
        
    }, [totalPageCount, currentPage])

    // const toggle = ()=>{
    //     setModal(!modal);
    // }

    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

   
     const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setShowDeleteAlert(false); 
        setModalAlert(false);   
    };
    
   
    useEffect(()=>{
        getSample();
    },[history.location]);


    const getSample = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "CatMachineSanitary/List");

        if (respuesta.code === 200) {
            let listcatMachinesSanitary= [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach( (data,index) => {
                    
                let posicion = index + 1;
                let visibleTable = false;
                
                if (posicion > startItems && posicion <= endItems) {
                    visibleTable = true;
                }

                listcatMachinesSanitary.push({
                        id_machine_sanitary: data.id_machine_sanitary,
                        descripcion: data.descripcion,
                        clave: data.clave
                    });
                });
                setcatMachinesSanitary(listcatMachinesSanitary);
                setDatacatMachinesSanitarySearch(listcatMachinesSanitary);
            }
        }
    }

    
    const handleCreate = () => {
        handleUpdateValues({
            descripcion: "",
            clave: "",
        });

        setValidaciones({
            descripcion_valid: false,
        });

        setid_machine_sanitary(0);
        setMethod("create");
        setModalTitle("Crear un nuevo Equipo/Consumible");
        openDialog("Crear un nuevo Equipo/Consumible", "create");
    }   

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "CatMachineSanitary/Create");
        if (respuesta.code === 200) {
            getSample();
            createSweet("create", "success", "Éxito!", "Creado con éxito");
            setLoading(false);
            closeDialog();
        }
    }

    const handleUpdate = (id_machine_sanitary) => {
        let catMachinesSanitarytemp = catMachinesSanitary.find(s => s.id_machine_sanitary === id_machine_sanitary);

        handleUpdateValues({
            descripcion: catMachinesSanitarytemp.descripcion,
            clave: catMachinesSanitarytemp.clave,
        });

        setValidaciones({
            descripcion_valid: false,
        });

        setid_machine_sanitary(id_machine_sanitary);
        setMethod("update");
        setModalTitle("Modificación de Equipo/Consumible");
        openDialog("Modificación de Equipo/Consumible", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let body = {
            id_machine_sanitary: id_machine_sanitary,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);
        
        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "CatMachineSanitary/Update");

        if (respuesta.code === 200) {
            getSample();
            createSweet("create", "success", "Exito!", "Equipo/Consumible actualizada");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }

    const handleDelete = (id_machine_sanitary) => {
        
        let catMachinesSanitarytemp = catMachinesSanitary.find(s => s.id_machine_sanitary === id_machine_sanitary);

        handleUpdateValues({
            descripcion: catMachinesSanitarytemp.descripcion,
            clave: catMachinesSanitarytemp.clave,
        });

        setid_machine_sanitary(id_machine_sanitary);
        setMethod("delete");
        setModalTitle("eliminar");
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `CatMachineSanitary/${id_machine_sanitary}`);

        if (respuesta.code === 200) {
            getSample();
            setLoading(false);
            createSweet("create", "success", "Exito!", "Equipo/Consumible ha sido eliminado");
            closeDeleteAlert();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }
       

    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.name === "" || formValues.descripcion.length < 3) {
            newValidations = {
                ...newValidations,
                descripcion_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                descripcion_valid: false
            }
        }
        setValidaciones(newValidations);

        return statusValidation;
    }

    const handleExcelMachineSanitary = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

            const _report = catMachinesSanitary.map((item, index) => ({
                "#": index + 1,
                Clave: item.clave || "----",
                Descripción: item.descripcion || "---",                
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Listados_Equipo_Consumible");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catálogo_equipo_consumibles.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };


    const handleSearch = (e) => {
        setSearchMachineSanitary(e);

        let busqueda = e.toUpperCase();
        let newMachineS = [];

        if (busqueda === "") {
            setcatMachinesSanitary([...dataDatacatMachinesSanitarySearch]); 
        } else {
            dataDatacatMachinesSanitarySearch.forEach(element => {
                let cadena = element.descripcion.toUpperCase();
                if (cadena.indexOf(busqueda) > -1) {
                    newMachineS.push(element);
                }
            });
            setcatMachinesSanitary(newMachineS);
        }
    }

    const handleClearMicSample = () => {
        setSearchMachineSanitary("");                         
        localStorage.removeItem("globalFilter");    
        setcatMachinesSanitary([...dataDatacatMachinesSanitarySearch]);
    };

    return {
        catMachinesSanitary, descripcion,clave, validaciones,
        method, 
        handleInputChange, loading, 
        closeDialog, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        showDeleteAlert, modalAlert, closeDeleteAlert,
        handleExcelMachineSanitary, loadingExport, handleClearMicSample, handleSearch, searchMachineSanitary,
        dataDatacatMachinesSanitarySearch
    }

}




